import { render, staticRenderFns } from "./yuxiangSalaryReport.vue?vue&type=template&id=70f4a30a&"
import script from "./yuxiangSalaryReport.vue?vue&type=script&lang=js&"
export * from "./yuxiangSalaryReport.vue?vue&type=script&lang=js&"
import style0 from "./yuxiangSalaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports